import {
	useRef,
} from 'react';
import {
	Card,
} from 'react-bootstrap';

const MAX_POSSIBLE_HEIGHT = 900;

const Accordion = ({
	maxHeight,
	expanded,
	children,
	className,
}: any) => {
	const ref = useRef<any>();

	return (
		<Card.Text as="h4" ref={ref}>
			<div
				className={className}
				style={{
					maxHeight: expanded ? MAX_POSSIBLE_HEIGHT : maxHeight,
					overflow: 'hidden',
					transition: 'max-height 0.4s ease',
				}}
			>
				{children}
			</div>
		</Card.Text>
	);
};

export default Accordion;